import Markdown from 'markdown-to-jsx'
import React from 'react'
import { useFormContext, useWatch, type RegisterOptions } from 'react-hook-form'

import { useFormError } from '@/legacy-src/components/formFields/hooks/useFormError'
import { cn } from '@/legacy-src/lib/utils'

import Icon from '../icons/Icon'
import ErrorMessage from './ErrorMessage'
import { useIsFieldInvalid } from './hooks/useIsFieldInvalid'

type CheckboxFieldProps = {
  readonly label: string
  readonly value?: string | number
  readonly name: string
  readonly checked?: boolean
  readonly className?: string
  readonly type?: string
  readonly onChange?: (event: any) => void
  readonly registerOptions?: RegisterOptions
  readonly buttonStyle?: boolean
  readonly listCol?: string
  readonly text?: string
  readonly useTileStyles?: boolean
  readonly link?: string
  readonly prefixText?: string
  readonly disabled?: boolean
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
  label,
  name,
  className,
  registerOptions,
  link,
  checked,
  onChange,
  type,
  disabled,
  ...props
}) => {
  const isInvalid = useIsFieldInvalid(name)
  const { register } = useFormContext()
  const value = useWatch({ name })
  const error = useFormError(name)
  const isChecked = onChange ? value?.length && value.some((item) => item === props.value) : value

  return (
    <div
      className={cn(
        'checkbox__item',
        { [`checkbox__item--${type}`]: !!type, 'checkbox__item--checked': !!isChecked },
        'custom-control',
        { 'opacity-50': disabled },
        className,
      )}
    >
      <div className="custom-checkbox">
        <label className={`custom-control-label ${isChecked ? 'checked' : ''} ${error ? 'text-danger' : ''}`}>
          {onChange !== undefined && type === 'plain' && (
            <Icon color="brown" icon={isChecked ? 'checkboxFull' : 'checkbox'} />
          )}
          <input
            {...register(name, registerOptions)}
            {...props}
            type="checkbox"
            onClick={onChange}
            className={`custom-control-input${isInvalid ? 'is-invalid' : ''}`}
            disabled={disabled}
          />
          <Markdown
            options={{
              overrides: {
                a: {
                  props: {
                    target: '_blank',
                  },
                },
              },
            }}
          >
            {label}
          </Markdown>
        </label>
      </div>
      {!onChange && <ErrorMessage name={name} />}
    </div>
  )
}

export default CheckboxField
